/**
 * UserFormModal — edycja użytkownika osadzona w oknie modalnym, NAD oknem wyboru opiekuna
 * (akcja „Edytuj" w tabeli użytkowników na dokumencie). Mirror `ContractorFormModal`: zamiast
 * osobnej formatki reużywa pełnej karty (`UserDetail embedded`) — jedno źródło prawdy dla
 * strony i okna. Tylko edycja (tworzenie/zaproszenie zostaje na stronie Użytkownicy).
 */

import { useState } from 'react';
import { useTranslation } from 'react-i18next';

import { Modal } from '@/components/Modal';
import { UserDetail } from '@/pages/UserDetail';

export interface UserFormModalProps {
  open: boolean;
  userId?: string;
  onClose: () => void;
  /** Po udanym zapisie — id zapisanego użytkownika. */
  onSaved?: (id: string) => void;
  'data-testid'?: string;
}

export function UserFormModal({
  open,
  userId,
  onClose,
  onSaved,
  'data-testid': testId,
}: UserFormModalProps) {
  const { t } = useTranslation();
  // Okno zostaje otwarte po zapisie (karta wraca do podglądu) — zapis zeruje „coś wpisano",
  // żeby Esc zaraz po zapisie nie pytał o porzucenie zmian, które już zapisano.
  const [savedRev, setSavedRev] = useState(0);
  const handleSaved = (id: string) => {
    setSavedRev((rev) => rev + 1);
    onSaved?.(id);
  };

  return (
    <Modal
      open={open && !!userId}
      onClose={onClose}
      size="2xl"
      fixedHeight
      expandable
      guardUnsaved
      guardResetKey={savedRev}
      title={t('tenant.users.formModal.editTitle')}
    >
      <div data-testid={testId ?? 'user-form-modal'}>
        {userId && <UserDetail embedded={{ userId, onSaved: handleSaved, onCancel: onClose }} />}
      </div>
    </Modal>
  );
}
